{
  "metadata": {
    "id": "tokyonight-dark",
    "name": "Tokyonight",
    "description": "Портировано из темы «Tokyonight» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "tokyonight.json",
      "project": "folke",
      "url": "https://github.com/folke/tokyonight.nvim",
      "upstreamFile": "packages/ui/src/theme/themes/tokyonight.json",
      "license": "Apache-2.0",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 23.6,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.48,
      "paletteMaxS": 0.512,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.0,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 27.3,
      "syntaxVsTextMinDeltaE": 19.9,
      "chartsMinDeltaE": 29.5,
      "textSeparationDeltaE": 18.2,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#7aa2f7",
      "hover": "#8aadf8",
      "active": "#95b5f9",
      "foreground": "#000000",
      "muted": "#7aa2f780",
      "emphasis": "#7aa2f7"
    },
    "surface": {
      "background": "#1a1b26",
      "foreground": "#c0caf5",
      "muted": "#2b2d3b",
      "mutedForeground": "#989eb9",
      "elevated": "#333646",
      "elevatedForeground": "#c0caf5",
      "raised": "#4b4f63",
      "raisedForeground": "#c0caf5",
      "overlay": "#1a1b26cc",
      "subtle": "#232531"
    },
    "interactive": {
      "border": "#4d5166",
      "borderHover": "#484c60",
      "borderFocus": "#7aa2f7",
      "selection": "#c0caf529",
      "selectionForeground": "#c0caf5",
      "focus": "#7aa2f759",
      "focusRing": "#7aa2f761",
      "cursor": "#c0caf5",
      "hover": "#c0caf51c",
      "active": "#c0caf529"
    },
    "status": {
      "error": "#f7768e",
      "errorForeground": "#000000",
      "errorBackground": "#f7768e24",
      "errorBorder": "#f7768e73",
      "warning": "#e0af68",
      "warningForeground": "#000000",
      "warningBackground": "#e0af6824",
      "warningBorder": "#e0af6873",
      "success": "#9ece6a",
      "successForeground": "#000000",
      "successBackground": "#9ece6a24",
      "successBorder": "#9ece6a73",
      "info": "#7dcfff",
      "infoForeground": "#000000",
      "infoBackground": "#7dcfff24",
      "infoBorder": "#7dcfff73"
    },
    "pr": {
      "open": "#9ece6a",
      "draft": "#a4aac2",
      "blocked": "#e0af68",
      "merged": "#ff9e64",
      "closed": "#f7768e"
    },
    "syntax": {
      "base": {
        "background": "#3b3d4f",
        "foreground": "#c0caf5",
        "comment": "#a3a9c5",
        "keyword": "#bb9af7",
        "string": "#1ad517",
        "number": "#ff9e64",
        "function": "#7dcfff",
        "variable": "#c0caf5",
        "type": "#a7edae",
        "operator": "#deeee3"
      },
      "tokens": {
        "commentDoc": "#a3a9c5",
        "stringEscape": "#deeee3",
        "keywordImport": "#bb9af7",
        "storageModifier": "#bb9af7",
        "functionCall": "#7dcfff",
        "method": "#7dcfff",
        "variableProperty": "#7dcfff",
        "variableOther": "#c0caf5",
        "variableGlobal": "#ff9e64",
        "variableLocal": "#deeee3",
        "parameter": "#c0caf5",
        "constant": "#ff9e64",
        "class": "#a7edae",
        "className": "#a7edae",
        "interface": "#a7edae",
        "struct": "#a7edae",
        "enum": "#a7edae",
        "typeParameter": "#a7edae",
        "namespace": "#a7edae",
        "module": "#bb9af7",
        "tag": "#bb9af7",
        "jsxTag": "#bb9af7",
        "tagAttribute": "#7dcfff",
        "tagAttributeValue": "#1ad517",
        "boolean": "#ff9e64",
        "decorator": "#bb9af7",
        "label": "#7dcfff",
        "regexp": "#1ad517"
      }
    },
    "charts": {
      "series": [
        "#7aa2f7",
        "#7dcfff",
        "#9ece6a",
        "#e0af68",
        "#f7768e"
      ]
    },
    "chat": {
      "background": "#1a1b26",
      "userMessage": "#c0caf5",
      "userMessageBackground": "#333646",
      "assistantMessage": "#c0caf5",
      "assistantMessageBackground": "#2b2d3b",
      "timestamp": "#a4aac2",
      "divider": "#4d5166",
      "typing": "#a4aac2"
    },
    "loading": {
      "spinner": "#7aa2f7",
      "spinnerTrack": "#2b2d3b",
      "skeleton": "#2b2d3b",
      "shimmer": "#434559"
    },
    "tools": {
      "background": "#2b2d3b",
      "border": "#4d5166",
      "headerHover": "#424457",
      "icon": "#7aa2f7",
      "title": "#c0caf5",
      "description": "#a4aac2",
      "edit": {
        "added": "#9ece6a",
        "addedBackground": "#9ece6a24",
        "removed": "#f7768e",
        "removedBackground": "#f7768e24",
        "modified": "#7dcfff",
        "modifiedBackground": "#7dcfff24",
        "lineNumber": "#a4aac2"
      }
    },
    "markdown": {
      "heading1": "#c0caf5",
      "heading2": "#c0caf5",
      "heading3": "#c0caf5",
      "heading4": "#c0caf5",
      "link": "#7aa2f7",
      "linkHover": "#8aadf8",
      "inlineCode": "#1ad517",
      "inlineCodeBackground": "#2b2d3b",
      "blockquote": "#a4aac2",
      "blockquoteBorder": "#4d5166",
      "listMarker": "#7aa2f7bf",
      "bold": "#c0caf5",
      "italic": "#c0caf5e6",
      "strikethrough": "#a4aac2",
      "hr": "#4d5166"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#c56355",
        "foreground": "#000000",
        "contrast": 5.29
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#dfb1a3",
        "foreground": "#000000",
        "contrast": 10.96
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#caa55d",
        "foreground": "#000000",
        "contrast": 9.05
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#bacd64",
        "foreground": "#000000",
        "contrast": 12.0
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#c9dfac",
        "foreground": "#000000",
        "contrast": 14.63
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#62cb5f",
        "foreground": "#000000",
        "contrast": 10.23
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#85d794",
        "foreground": "#000000",
        "contrast": 12.15
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#68c2aa",
        "foreground": "#000000",
        "contrast": 9.89
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#abd6dd",
        "foreground": "#000000",
        "contrast": 13.39
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#5ca7c7",
        "foreground": "#000000",
        "contrast": 7.81
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#4e5dc0",
        "foreground": "#ffffff",
        "contrast": 5.75
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#9fa1dc",
        "foreground": "#000000",
        "contrast": 8.61
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a77cd1",
        "foreground": "#000000",
        "contrast": 6.45
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#c659c2",
        "foreground": "#000000",
        "contrast": 5.61
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#dfa2c8",
        "foreground": "#000000",
        "contrast": 10.14
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c55786",
        "foreground": "#000000",
        "contrast": 5.08
      }
    ]
  }
}
